// import React from 'react';
import { useState } from 'react'
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton } from '@mui/material';
// import logo from '../assets/racl_logo.jpg';
//import logo from '../assets/tcls_logo1.png';
import logo from '../assets/tricls-logo.png';

import * as React from 'react';
// import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

// dropdown
// import { Dropdown } from '@mui/base/Dropdown';
// import { MenuButton } from '@mui/base/MenuButton';
// import { Menu } from '@mui/base/Menu';
// import { MenuItem } from '@mui/base/MenuItem';

// import React, { useContext } from 'react';
// import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import UserMenu from './UserMenu';
// import { AuthContext } from '../contexts/AuthContext';
// import { NotificationContext } from '../contexts/NotificationContext';



export default function Header(){

    // const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget)
    }

    
    const handleClose = () => {
        setAnchorEl(null)

    }


    const handleClose1 = () => {
        // setAnchorEl(null)
        alert("Menu 1 closed")
    }

        const handleClose2 = () => {
        alert("Menu 2 closed")
        setAnchorEl(null)

    }

        const handleClose3 = () => {
        setAnchorEl(null)
        alert("Menu 3 closed")
    }

    function handleNavigation(e){
        e.preventDefault();
    }

    return(
        <Paper sx={{
            zIndex: 999,
            position: 'fixed',
            top:0,
            width: '100%'
        }}
        
            component ="header"
            square variant='outlined'

        >
            <AppBar position="static"  sx={{backgroundColor: '#ffcc00'}}>
                <Container maxWidth="xl" >
                    <Grid container spacing={1}>
                        <Grid item xs={6} sm={1}>
                            <Box textAlign="left" sx={{flexGrow:0, pt: 0, pl:0}}>
                                <a href="/">
                                    <img src ={logo} alt="logo" width={80}  height={54} />
                                </a>
                                
                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='home'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'large', display: 'block'}}
                                    href='/home'>
                                        Home
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='home'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'medium', display: 'block'}}
                                    href='/newsletter'>
                                        News
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item xs={1} sm={0.5} />

                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='services'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'large', display: 'block'}}
                                    href='/student'>
                                        Students
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='resources'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'large', display: 'block'}}
                                    href='/language-class'>
                                        Classes
                                </Button>
                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='resources'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'large', display: 'block'}}
                                    href='/activity-class'>
                                        Activites
                                </Button>
                            </Box>
                        </Grid>                            
                        
                        <Grid item xs={6} sm={1}>
                            <Box>
                                {/* <Button 
                                    key='resources'
                                    component={Link}
                                    sx={{my:2, color: 'white', size: 'large', display: 'block'}}
                                    href='/'>
                                        Clubs
                                </Button> */}



                                {/* <Menu
                                    id="basic-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    slotProps={{
                                    list: {
                                        'aria-labelledby': 'basic-button',
                                    },
                                    }}
                                >
                                    <MenuItem onClick={handleClose}>Profile</MenuItem>
                                    <MenuItem onClick={handleClose}>My account</MenuItem>
                                    <MenuItem onClick={handleClose}>Logout</MenuItem>
                                </Menu> */}
                                <Button 

                                    key='resources'

                                    sx={{my:2, color: 'black', size: 'large', display: 'block'}}

                                        id="menu-clubs"
                                        onClick={handleMenu}
                                    >
                                        Clubs
                                </Button>

                                {/* <Button color="inherit" onClick={handleMenu}>Clubs</Button> */}
                                    <Menu
                                        id="main-menu"
                                        anchorEl={anchorEl}
                                        open={open}
                                        onClose={handleClose}
                                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    >
                                        
                                        {/* <MenuItem onClick={handleClose}>Badminton</MenuItem>
                                        <MenuItem onClick={handleClose}>Cross Countrey</MenuItem>
                                        <MenuItem onClick={handleClose}>Soccer</MenuItem> */}
                                        <MenuItem component="a"  href='/club'>Dragon Boat Club</MenuItem>
                                        <MenuItem component="a"  href='/club'>Dragon Dance Club</MenuItem>
                                        <MenuItem component="a"  href='/club'>Youth Dragon Dance Club</MenuItem>
                                        <MenuItem component="a"  href='/club'>ImPress Year Book Club</MenuItem>
                                        {/* <MenuItem onClick={handleClose1}>Running Club</MenuItem> */}
                                        <MenuItem component="a"  href='/club'>Running Club</MenuItem>

                                    </Menu>

                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='resources'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'large', display: 'block'}}
                                    href='/pta'
                                >
                                        Events
                                </Button>

                            </Box>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='resources'
                                    component={Link}
                                    sx={{my:2, color: 'black', size: 'medium', display: 'block'}}
                                    href='/registration'
                                >
                                    Registration
                                </Button>
                            </Box>
                        </Grid>


                        <Grid item xs={2} sm={0.5} />

                        {/* <Grid item xs={6} sm={1}>
                            <Box>
                                <Button 
                                    key='signup'
                                    component={Link}
                                    sx={{my:2, color: 'white', size: 'large', display: 'block'}}
                                    href='/signup'>
                                        SignUp
                                </Button>
                            </Box>
                        </Grid> */}

                        <Grid item xs={6} sm={1}>
                            <Box>
                                {/* <Button 
                                    key='signin'
                                    component={Link}
                                    sx={{my:2, color: 'white', size: 'large', display: 'block'}}
                                    href='/signin'>
                                        SignIn
                                </Button> */}
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </AppBar>

        </Paper>

    );
}